<template name="ec_home">
  <div>
    <section id="sliders">
      <!--最新赛事轮播图-->
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div
            v-for="(game,index) in banners"
            :key="index"
            class="swiper-slide"
            :style="{'background-image': `url('${game.cover}')`}"
          ></div>
        </div>
      </div>
    </section>
    <section id="projects">
      <!---展示供应商赛事，按时间倒序排-->
      <div class="container">
        <div class="matchs">
          <div class="head">
            <h3 class="title">赛事活动</h3>
            <span class="line">精彩赛事活动为您呈现</span>
          </div>
          <div v-for="(sgames,index) in games" :key="index" class="row">
            <template v-for="(item,sindex) in sgames">
              <div
                v-if="item.more"
                :key="`${index}-${sindex}`"
                :class="item.class+' col-xs-12 case'"
              >
                <div class="img_case more" @click="$router.replace('/projects')">
                  <p>更多 >></p>
                </div>
              </div>
              <div
                v-else
                :key="`${index}-${sindex}`"
                :class="item.class+' col-xs-12 case'"
                :style="{'height': '25rem', 'background-size': 'cover','background-repeat': 'no-repeat', 'background-position': 'center center', 'background-image': `url(${item.cover}?x-oss-process=style/thumb)`}"
              >
                <div class="info">
                  <span>{{item.cat.name}}</span>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </section>
    <section id="medias">
      <!---展示供应商所有新闻动态-->
      <div class="container">
        <div class="news">
          <div class="head">
            <h3 class="title">新闻资讯</h3>
            <span class="line">让营销变得简单</span>
          </div>
          <div class="row">
            <div v-for="(item,index) in news" :key="index" class="col-md-4 col-sm-6 col-xs-12">
              <a
                :href="item.link"
                class="new_body"
                :title="item.title"
                target="_blank"
                tabindex="0"
              >
                <div v-if="item.coverpos==='top'" class="img">
                  <img :src="item.cover" style="width: 100%;height: auto;" />
                </div>
                <div class="text">
                  <div class="content">
                    <p class="date">{{item.createtime|dateTime}}</p>
                    <h3 class="title">
                      <span>{{item.title}}</span>
                    </h3>
                    <p class="description">{{item.summary}}</p>
                  </div>
                </div>
                <div v-if="item.coverpos==='bottom'" class="img">
                  <img :src="item.cover" style="width: 100%;height: auto;" />
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="lives">
      <!---展示图片和视频-->
      <div class="container">
        <div class="lives">
          <div class="head">
            <h3 class="title">赛事现场</h3>
            <span class="line">准备好去现场了吗</span>
          </div>
          <div class="row">
            <div
              v-for="(pitem,index) in posts"
              :key="index"
              class="portfolio-item col-md-3 col-sm-4 col-xs-12"
            >
              <img :src="pitem.images[0]" style="height: 150px;" class="img-responsive" alt />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="about">
      <div class="container">
        <!---供应商介绍信息-->
        <div class="about">
          <div class="head">
            <h3 class="title">关于我们</h3>
            <span class="line">我们致力于为您呈现精彩赛事活动</span>
          </div>
          <div class="map" style="margin-bottom: 20px;">
            <iframe
              v-if="ecdata"
              :src="'/map.html?'+ecdata"
              width="100%"
              height="280"
              frameborder="0"
              scrolling="no"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import _ from "underscore";
export default {
  data() {
    return {
      GAMES: [],
      news: [],
      posts: [],
      ec: null,
    };
  },
  computed: {
    banners() {
      return this.GAMES;
    },
    games() {
      let games = this.GAMES;
      let allgames = [[], []];
      if (games.length === 4) {
        games[0].class = "col-lg-7 col-md-7";
        games[1].class = "col-lg-5 col-md-5";
        games[2].class = "col-lg-4 col-md-4";
        games[3].class = "col-lg-4 col-md-4";
        allgames[0].push(games[0], games[1]);
        allgames[1].push(games[2], games[3], {
          more: true,
          class: "col-lg-4 col-md-4",
        });
      } else if (games.length === 3) {
        games[0].class = "col-lg-7 col-md-7";
        games[1].class = "col-lg-5 col-md-5";
        games[2].class = "col-lg-7 col-md-7";
        allgames[0].push(games[0], games[1]);
        allgames[1].push(games[2], { more: true, class: "col-lg-5 col-md-5" });
      } else if (games.length === 2) {
        games[0].class = "col-lg-4 col-md-4";
        games[1].class = "col-lg-4 col-md-4";
        allgames[0].push(games[0], games[1], {
          more: true,
          class: "col-lg-4 col-md-4",
        });
      } else if (games.length === 1) {
        games[0].class = "col-lg-7 col-md-7";
        allgames[0].push(games[0], { more: true, class: "col-lg-5 col-md-5" });
      }
      return allgames;
    },
    ecdata() {
      if (this.ec)
        return encodeURIComponent(
          JSON.stringify(_.pick(this.ec, ["name", "address", "location"]))
        );
      return false;
    },
  },
  methods: {
    getdata() {
      this.$api
        .post("/wapi", {
          method: "ssy-app/home/data",
          data: {},
        })
        .then((res) => {
          if (res.code !== 0) return;
          this.GAMES = res.data.games;
          for (let i = 0; i < res.data.news.length; i++) {
            if (i === 1) res.data.news[i].coverpos = "top";
            else res.data.news[i].coverpos = "bottom";
          }
          this.news = res.data.news;
          this.posts = res.data.posts;
          this.ec = res.data.ec;
          if (res.data.games.length > 0) {
            setTimeout(() => {
              var mySwiper = new Swiper(".swiper-container", {
                autoplay: 3000,
                speed: 300,
              });
            }, 1000);
          }
        })
        .catch((err) => {});
    },
  },
  mounted() {
    this.getdata();
  },
};
</script>
<style>
.matchs .case {
  padding-left: 5px;
  padding-right: 5px;
  background-clip: content-box;
  box-sizing: border-box;
}

.swiper-container {
  width: 100vw;
  height: 50rem;
  overflow: hidden;
}

.swiper-slide {
  height: 100%;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}
.about h4 {
  margin: 0;
  border-bottom: 1px solid #eee;
  padding-bottom: 5px;
}
.about .info p {
  line-height: 30px;
  text-indent: 20px;
}
</style>